import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	titleText: {
		fontSize: "32px",
		lineHeight: "24px",
		color: colors.gray[700]
	},
	inviteCard: {
		padding: "8px"
	},
	subtitleText: {
		color: colors.getPrimaryColor(),
		fontWeight: 500,
		textTransform: "uppercase"
	},
	nameText: {
		fontWeight: 600,
		fontSize: "16px"
	},
	chipPending: {
		background: colors.blue[100],
		color: colors.gray[700]
	},
	copyContainer: {
		height: "100%"
	},
	copyButton: {
		height: "100%",
		width: "100%",
		fontSize: "14px",
		lineHeight: "24px",
		borderRadius: "0px 6px 6px 0px",
		marginLeft: "-3px"
	},
	copyInput: {
		borderRadius: "6px 0px 0px 6px"
	},
	teamsListContainer: {
		background: colors.gray[50],
		borderRadius: "5px",
		padding: theme.spacing(0, 2),
		marginTop: theme.spacing(1),
		maxHeight: "150px",
		overflowY: "scroll"
	},
	editButton: {
		marginLeft: theme.spacing(2)
	},
	noTeamListed: {
		textTransform: "uppercase",
		marginTop: "65px",
		marginBottom: "65px"
	},
	textContainer: {
		overflow: "hidden",
		textOverflow: "ellipsis"
	},
	iconButton: {
		background: colors.gray[100],
		opacity: 0.8,
		borderRadius: "8px",
		gap: "8px",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		},
		width: "64px",
		height: "64px",
		color: colors.gray[700],
		fontSize: "20px"
	},
	attendantToggle: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: theme.spacing(3.5),
		borderRadius: theme.spacing(2),
		width: "100%",
		padding: theme.spacing(1, 1.5),
		fontSize: theme.spacing(1.5),
		marginTop: 6
	},
	attendantToggleText: {
		fontStyle: "normal",
		fontSize: theme.spacing(1.75),
		color: colors.gray[700],
		fontWeight: 600,
		paddingLeft: theme.spacing(0.5),
		height: "100%",
		paddingBottom: theme.spacing(2.75)
	},
	attendanceList: {
		maxHeight: 280,
		overflowY: "auto",
		scrollbarGutter: "stable",
		display: "flex",
		flexDirection: "column",
		gap: "8px"
	},
	attendanceItem: {
		padding: "10px 16px",
		minWidth: 0
	},
	attendanceAvatar: {
		width: 40,
		height: 40
	},
	attendanceName: {
		fontWeight: 600
	}
}))

export default useStyles
